// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"22ab5eb6","254":"9a7321d9","272":"a6028958","314":"3c577c67","426":"8ece958c","605":"2942f205"}[chunkId] + ".chunk.js";
};